export default "__VITE_ASSET__DF3fiaS5__"